import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setWalletBalance, addFunds } from "../../Redux/Wallet";

import { api } from "../../api/api";
import { Wallet_ledger, Wallet_url } from "../../api/urls";
import {
  Box,
  Button,
  Typography,
  TextField,
  Paper,
  // Divider,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const WalletUI = () => {
  const dispatch = useDispatch();
  const balance = useSelector((state) => state.wallet.balance);
  const [amount, setAmount] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [showAllTransactions, setShowAllTransactions] = useState(false);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const fetchWalletData = async () => {
  //     try {
  //       const response = await api.get(Wallet_url);

  //       dispatch(setWalletBalance(response?.data?.wallet_money));
  //       setTransactions(response.data.wallet_log);
  //     } catch (error) {
  //       console.error("Error fetching wallet data:", error.message);
  //     }
  //   };

  //   fetchWalletData();
  // }, [dispatch]);
  useEffect(() => {
    const fetchWalletData = async () => {
      try {
        const response = await api.get(Wallet_url);

        dispatch(setWalletBalance(response?.data?.wallet_money));
        setTransactions(response.data.wallet_log);
      } catch (error) {
        console.error("Error fetching wallet data:", error.message);
      } finally {
        setLoading(false); // ✅ stop skeleton when data loaded
      }
    };

    fetchWalletData();
  }, [dispatch]);

  const handlePresetAmount = (value) => {
    setAmount(value);
  };

  const handlePayment = async (selectedAmount) => {
    const finalAmount = selectedAmount || parseFloat(amount);
    if (!finalAmount || finalAmount <= 0) {
      console.error("Invalid amount entered");
      return;
    }

    try {
      setLoading(true);
      const response = await api.post(Wallet_ledger, { amount: finalAmount });

      if (response.data.pay) {
        dispatch(addFunds(finalAmount));
        window.location.href = response.data.pay;
        // window.open(response.data.pay, "_blank");
      } else {
        throw new Error("Payment link not received");
      }
    } catch (error) {
      console.error("Error processing payment:", error.message);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        p: 3,
        backgroundColor: "#fff",
        borderRadius: "8px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Box sx={{ maxWidth: "1440px", mx: "auto" }}>
        <Typography
          variant="h4"
          sx={{ mb: 3, fontSize: "24px", textAlign: "left" }}
        >
          Pentagon Wallet
        </Typography>

        {/* Balance */}
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #ddd",
            p: 2,
            borderRadius: "8px",
            // backgroundColor: "#f3f3f3",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "20px" }}>Total Balance</Typography>
          <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
            ₹ {balance}
          </Typography>
        </Paper>

        {/* Add Money */}
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #ddd",
            p: 2,
            borderRadius: "8px",
            // backgroundColor: "#fff",
            mt: 3,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 500, mb: 1 }}>
            Add Money to Wallet
          </Typography>

          <TextField
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="₹ 0.00"
            inputProps={{ min: 0 }}
            sx={{
              width: { md: "300px" },

              fontSize: "16px",
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "40px",
              },
              "& input": {
                fontSize: "16px",
                padding: "0 14px",
                "&::placeholder": {
                  color: "black", // ← your placeholder color
                  opacity: 1, // required in some browsers
                },
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "8px",
              mb: 2,
              width: "100%",
              maxWidth: "300px",
            }}
          >
            {[500, 1000, 1500, 2000].map((value) => (
              <Button
                key={value}
                variant="outlined"
                onClick={() => handlePresetAmount(value)}
                sx={{
                  borderRadius: "6px",
                  // backgroundColor: "#e0e0e0",
                  fontSize: "14px",
                  minWidth: "0",
                  // padding: "6px",

                  pt: "4px", // padding-top
                  pr: "10px", // padding-right
                  pb: "4px", // padding-bottom
                  pl: "10px", // padding-left

                  border: "1px solid #ccc",
                  color: "#000",
                  "&:hover": {
                    backgroundColor: "#d0d0d0",
                    border: "1px solid #bbb",
                  },
                }}
              >
                ₹ {value}
              </Button>
            ))}
          </Box>

          <Button
            onClick={() => handlePayment()}
            disabled={loading}
            sx={{
              width: "100%",
              maxWidth: "300px",
              backgroundColor: loading ? "#c2c2c2ff" : "#000",
              color: "#fff",
              // padding: "12px",
              padding: "6px 11px",
              borderRadius: "6px",
              fontSize: "16px",
              textTransform: "none",
              mt: 2, // margin-top (theme spacing, 2 = 16px)
              mb: 5, // margin-bottom
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            Continue
          </Button>
        </Paper>

        {/* Transaction History */}
        <Box mt={3}>
          {transactions.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                Your Transactions
              </Typography>
              {/* <Button
              onClick={() => setShowAllTransactions(!showAllTransactions)}
              sx={{
                color: "#007BFF",
                textTransform: "none",
                fontSize: "14px",
              }}
            >See More</Button> */}
            </Box>
          )}

          <Box mt={2}>
            {loading
              ? // ✅ Skeleton Loader UI for Wallet Transactions
                [...Array(4)].map((_, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{ p: 2, borderRadius: "8px", mb: 2 }}
                  >
                    <Skeleton
                      variant="text"
                      animation="wave"
                      height={20}
                      width="60%"
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      height={20}
                      width="40%"
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      height={20}
                      width="50%"
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      height={20}
                      width="30%"
                    />
                  </Paper>
                ))
              : // ✅ Original Transaction mapping
                transactions?.map((txn, index) => (
                  <Paper
                    key={index}
                    elevation={0}
                   className="border-b pb-4 mb-4"
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <strong
                        className={`${
                          txn.paid_status === "Successful"
                            ? "text-green-700"
                            : "text-red-700"
                        }`}
                      >
                        {txn.paid_status}
                      </strong>{" "}
                      <span className="text-sm text-gray-500">{txn.date}</span>
                    </Typography>

                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <strong>{txn.text_to_display}</strong>
                      <span
                 
                        className={`${
                          txn.transaction_type === "CR"
                            ? "text-green-700"
                            : txn.transaction_type === "DR"
                            ? "text-red-700"
                            : "text-gray-400"
                        } font-medium`}
                      >
                        {txn.transaction_type === "CR"
                          ? `+ ₹ ${txn.amount}`
                          : txn.transaction_type === "DR"
                          ? `- ₹ ${Math.abs(txn.amount)}`
                          : `₹ ${Math.abs(txn.amount)}`}
                      </span>
                    </Typography>

                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <strong>Order ID:</strong> <span>{txn.order_id}</span>
                    </Typography>

                    <Typography
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <strong>Balance:</strong> <span>₹ {txn.balance}</span>
                    </Typography>
                  </Paper>
                ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WalletUI;
